import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ExportApiService} from '../../../services/api/export-api.service';
import * as FileSaver from 'file-saver';
import {Router} from '@angular/router';

@Component({
    selector: 'app-export-document-dialog',
    templateUrl: './export-document-dialog.component.html',
    styleUrls: ['./export-document-dialog.component.scss'],
    standalone: false
})
export class ExportDocumentDialogComponent implements OnInit {

  public isLoading = false;
  public entityUuid: string;

  public documents;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private exportApiService: ExportApiService,
              private router: Router,
              private snackBar: MatSnackBar,
              public dialogRef: MatDialogRef<unknown>) {

    this.entityUuid = data.entityUuid;
  }

  ngOnInit() {
    this.isLoading = true;

    this.exportApiService.getDocuments().subscribe((response) => {
      // @ts-ignore
      this.documents = response.data;
      this.isLoading = false;
    });
  }

  save() {
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(false);
  }

  startDocument(document: any) {
    if (document.workflowUuid) {
      this.close();
      return this.router.navigateByUrl('/admin/vehicles/' + this.entityUuid + '/workflows/' + document.workflowUuid + '?workflowType=prefill&prefillDocumentTemplateUuid=' + document.prefillDocumentTemplateUuid + '&filename=' + document.filename);
    }

    this.isLoading = true;

    this.exportApiService.processDocument(this.entityUuid, document.prefillDocumentTemplateUuid, null)
      .subscribe((result) => {
        this.isLoading = false;
        this.close();
        FileSaver.saveAs(result, document.filename);
      }, error => {
        this.isLoading = false;
        this.snackBar.open('Prišlo je do napake pri izdajanju dokumenta');
      });
  }
}
